import { memo, useMemo } from 'react'

import './index.scss'
import { useTime } from '../../../../../hooks/useTime'
import { SINGLE_TIME_UNIT } from '../../../../../data/variables'

const StopSpeedCol = memo(({ val, data }) => {
  const { calculateTimeDiff, minutesToLargestUnit } = useTime()

  const valueElem = useMemo(() => {
    const speed = parseFloat(val).toFixed(1)
    const lookup = { class: [], value: `${speed} km/h` }
    if (data.stop_start_date) {
      const stopDate = data.stop_start_date
      const timeDiff = calculateTimeDiff(stopDate)
      const { value, unit } = minutesToLargestUnit(timeDiff)
      lookup.value = `${value.toFixed(0)}${SINGLE_TIME_UNIT[unit]}`
    } else if (speed > 0) {
      lookup.class.push('speed')
    }

    return lookup
  }, [val, data])

  if (!val) return ''

  return (
    <div className={`StopSpeedCol ${valueElem.class.length ? valueElem.class.join(' ') : ''}`}>
      {valueElem.value}
    </div>
  )
})

export default StopSpeedCol
